// Stacking cards
if(document.querySelector(".collapsing-cards")) {
    if($('.collapsing-cards .expanding-cards').find('article').length > 1) {
        gsap.registerPlugin(ScrollTrigger);
        ScrollTrigger.matchMedia({
            
            // desktop only
            "(min-width: 992px)": function() {
                let tl = gsap.timeline({
                    scrollTrigger: {
                        end: "+=1000",
                        markers: false,
                        pin: true,
                        pinSpacing: true,
                        scrub: 2,
                        start: "top top",
                        trigger: ".expanding-cards",
                    }
                });

                tl.from(".row-item:nth-child(2)", {
                    yPercent: 100,
                });
                tl.from(".row-item:nth-child(3)", {
                    yPercent: 200,
                });
                tl.from(".row-item:nth-child(4)", {
                    yPercent: 300,
                });
                tl.from(".row-item:nth-child(5)", {
                    yPercent: 400,
                });
            }
        });
    }

    $(document).on('ready', function() {
        cardResize();
    });

    $(window).on('resize', function() {
       cardResize(); 
    });

    function cardResize () {
        $('.collapsing-cards .expanding-cards').find('article').each(function() {
            if($(this).find('.min-height').outerHeight() >= $(this).height()) {
                var padTop = parseInt($(this).css('padding-top'));
                var padBottom = parseInt($(this).css('padding-bottom'));
                $(this).css('height', $(this).find('.min-height').outerHeight()+padTop+padBottom);
                if($(this).parent('.expanding-cards').height() < $(this).outerHeight()) {
                    var padTop = parseInt($(this).parent('.expanding-cards').css('padding-top'));
                    var padBottom = parseInt($(this).parent('.expanding-cards').css('padding-bottom'));
                    $(this).parent('.expanding-cards').css('height', $(this).outerHeight()+padTop+padBottom);
                }
            } else {
                $(this).css('height', '');
                $(this).parent('.expanding-cards').css('height', '');
            }

        });
    }
}
